export default "__VITE_ASSET__ICRslvEC__"